import { usePageTitle } from '@/hooks/use-page-title'

interface PageTitleProps {
  children: React.ReactNode
}

/**
 * PageTitle component that sets the document title based on the current route
 * Wrap your routes with this component to automatically set page titles
 */
export const PageTitle = ({ children }: PageTitleProps) => {
  usePageTitle()
  return <>{children}</>
}

export default PageTitle
